import './index.styl';
import template from './index.jst';
import coach_template from './coach_template.jst';

import { View } from 'backbone.marionette';
import { User } from "../../../models";
import Radio from "backbone.radio";
import _ from 'lodash';

const playerComparisonChannel = Radio.channel('player:comparison');

export class PlayerComparisonStatsBox extends View {
	get template() {
		return this.model.get('is_coach_stats') ? coach_template : template;
	}

	get className() {
		return 'player-comparison-stats-box';
	}

	initialize() {
		this.model.set({
			has_assistant_coach: User.has_assistant_coach
		});

		this.listenTo(this.model, 'change', this.render);
		this.listenTo(playerComparisonChannel, 'show:data', this.init);
		this.listenTo(playerComparisonChannel, 'player:add', this.onPlayerAdd);
		this.listenTo(playerComparisonChannel, 'removed:player', this.onPlayerRemove);
		this.listenTo(playerComparisonChannel, 'add:favourite:player', this.onAddFavourite);
		this.listenTo(playerComparisonChannel, 'remove:favourite:player', this.onRemoveFavourite);
		this.listenTo(playerComparisonChannel, 'switch:to:multi:tab', this.switchToMulti);
		this.listenTo(playerComparisonChannel, 'switch:to:h2h:tab', this.switchToh2h);
	}

	switchToMulti() {
		this.model.switchToMulti();
	}

	switchToh2h() {
		this.model.switchToh2h();
	}

	onAddFavourite({ player_id }) {
		this.model
			.markAsFavourite(player_id)
			.trigger('change');
	}

	onRemoveFavourite({ player_id }) {
		this.model
			.unMarkAsFavourite(player_id)
			.trigger('change');
	}

	init({ actual_round_id, rounds }) {
		this.model
			.generateRoundsRange({ round_id: actual_round_id })
			.set({
				round_id: actual_round_id,
				rounds
			});

		return this;
	}

	onPlayerAdd({ player }) {
		this.model
			.addPlayer({ player })
			.generateStats()
			.resetBetterStats()
			.markBetterStats()
			.trigger('change');

		return this;
	}

	onPlayerRemove({ player }) {
		this.model.resetBetterStats();

		if (_.isArray(player)) {
			this.model.removePlayers({ players: player });
		}
		else {
			this.model.removePlayer({ player_id: player.id });
		}

		this.model
			.markBetterStats()
			.trigger('change');

		return this;
	}
}

export default PlayerComparisonStatsBox;